/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { permissionsLlmCheck } from "../../funcs/permissionsLlmCheck.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.LlmCheckRequest$inboundSchema,
};

export const tool$permissionsLlmCheck: ToolDefinition<typeof args> = {
  name: "permissions-llm-check",
  description: `Check user permission

Check whether the authenticated caller has a specific role on a resource.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await permissionsLlmCheck(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
